export default __webpack_public_path__ + "static/media/besoins.1a9ec9e4.jpeg";